export const { format: formatNumber } = new Intl.NumberFormat('de-DE', {});
